import { render, staticRenderFns } from "./Detail-OT.vue?vue&type=template&id=1de1848d"
import script from "./Detail-OT.vue?vue&type=script&lang=js"
export * from "./Detail-OT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports